import { getIcons } from "_helpers";
import { FilterOverview, FiltersTableList } from ".";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { filterActions } from "_store";
import { ReturnButton } from "_components";

export { FiltersList };

/**
 * Composant d'affichage de la page Filtres
 * Contient le tableau listant les filtres et l'encart présentant les détails d'un filtre
 * @returns 
 */
function FiltersList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const filter = useSelector(state => state.filters?.item);
    const filters = useSelector(state => state.filters);
    
    useEffect(() => {
        if(!filters?.list){
            dispatch(filterActions.getAllFilters());
        }
    }, []);

    useEffect(() => {
        if (filter){
            dispatch(filterActions.clearFilter());
        }
    }, []);

    return (
        <div>
            <div className='ml-10 pl-12'>
                <ReturnButton />
            </div>
            <div className='mx-10 px-12'>
                <div className='flex justify-end w-full mr-10'>
                    <button className='btn-custom btn-custom-primary' onClick={() => navigate('/filtres/add')}>
                        <img src={getIcons('addOutlined')} className='btn-custom-icon mt-[-4px]' alt='manage alerts' />
                        Créer un filtre
                    </button>
                </div>
                <div className='grid grid-cols-5 h-full mt-4'>
                    <div className="col-span-3 h-full">
                        <FiltersTableList />  
                    </div>
                    <div className="col-span-2 h-full pt-16">                        
                        <FilterOverview />
                    </div>
                </div>
            </div>
        </div>         
    );
}